<template lang="pug">
  //- Parent component that renders child routes
  router-view
</template>

<script>
export default {
}
</script>

<style scoped>
</style>